export default {
  beforeCreate () {
    if (__BROWSER__ && dataLayer) {
      dataLayer.push({ event: 'optimize.activate' })
    }
  },
}
